import { ChangeDetectionStrategy, Component } from "@angular/core";

@Component({
  selector: "member-detail-body-v2",
  templateUrl: "./member-detail-body-v2.component.html",
  styleUrls: ["./member-detail-body-v2.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MemberDetailBodyV2Component {
  selectedTab = "charts";
  view = 0;

  toggleTab(tab: string): void {
    this.selectedTab = this.selectedTab === tab ? "" : tab;
  }

  isSelectedTab(tabName: string): boolean {
    return this.selectedTab === tabName;
  }

  onViewClicked(event): void {
    this.view = event.index;
  }

}
